import type {ReactElement} from 'react';
import React from 'react';
import {useAppSelector} from '@/hooks';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {DefaultAnimationOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/default-animation-option/default-animation-option';
import type {AnimationPanelType} from '@Components/poster-editor/components/poster-editing-side-panel/components/default-animation-option/default-animation-options.types';

export interface DefaultAnimationOptionProps {
  onAnimationTypeClick: (type: AnimationPanelType) => void;
}

export function PageAnimationOption({...props}: DefaultAnimationOptionProps): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);

  if (!currentPageObject) {
    throw new Error('Unable to show animation options since the current page is null');
  }

  if (Object.keys(currentPageObject.items.itemsHashMap).length === 0) {
    return null;
  }

  return (
    <DefaultAnimationOption
      key={'page-level-animation-option'}
      introAnimation={currentPageObject.introAnimation.type}
      outroAnimation={currentPageObject.outroAnimation.type}
      onAnimationTypeClick={props.onAnimationTypeClick}
    />
  );
}
